const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  },
  {
    id: '#cart-summary',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #cart-summary'
  }
];

// Price formatter utility
const getFormattedPrice = () => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currencyDisplay: 'symbol',
    currency: window.Shopify?.currency?.active || 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
    this.setupCartEventListeners();
    this.parentElement.addEventListener(
      'shopify:section:select',
      () => this.open()
    );
    this.parentElement.addEventListener(
      'shopify:section:deselect',
      () => this.close()
    );
  }

  setupCartEventListeners() {
    document.addEventListener('drawerOpen', async () => {
      await this.handleCartUpdate();
    });

    document.addEventListener('sw:added', async () => {
      await this.handleCartUpdate();
    });
  }

  async handleCartUpdate() {
    try {
      const cartResponse = await fetch("/cart.js");
      const { total_price, items, item_count } = await cartResponse.json();

      if (window.cartSettings?.showTotalOnCheckoutBtn) {
        this.cartButtonUpdate(total_price);
      }
      this.customShipUpdate(total_price);
      
      const urgencyTimer = document.getElementById('CartDrawer-UrgencyTimer');

      if (item_count > 0) {
        const summaryElement = document.querySelector('.cart-drawer__summary');
        const shippingElement = document.querySelector('.custom_shipping');
        const shippingBar = document.getElementById('CartDrawer-ShippingBar');

        if (summaryElement) summaryElement.style.display = 'block';
        if (shippingElement) shippingElement.style.display = 'block';
        if (shippingBar) shippingBar.style.display = '';
        if (urgencyTimer) urgencyTimer.style.display = '';

        if (window.cartSettings?.cartShippingBarEnabled) {
          this.updateDrawerShippingBar(total_price);
        }

        // Check mystery gift if enabled
        if (window.cartSettings?.mystryGiftEnabled && window.cartSettings?.mystryGiftVariantId) {
          await this.checkMystry(items, item_count);
        }
      } else {
        const summaryElement = document.querySelector('.cart-drawer__summary');
        const shippingElement = document.querySelector('.custom_shipping');
        const shippingBar = document.getElementById('CartDrawer-ShippingBar');

        if (summaryElement) summaryElement.style.display = 'none';
        if (shippingElement) shippingElement.style.display = 'none';
        if (shippingBar) shippingBar.style.display = 'none';
        if (urgencyTimer) urgencyTimer.style.display = 'none';

        // Clear urgency timer when cart is empty
        try { localStorage.removeItem('cart_urgency_timer'); } catch(e) {}
      }
    } catch (error) {
      console.log('Cart update error:', error.message);
    }
  }

  cartButtonUpdate(total_price) {
    const buttonText = window.cartSettings?.checkoutButtonText || 'Veilig afrekenen';
    const showTotal = window.cartSettings?.showTotalOnCheckoutBtn !== false;

    const buttonElement = document.querySelector('.cartDrawerBtn');
    if (buttonElement) {
      if (showTotal) {
        const formattedPrice = getFormattedPrice();
        const currencySymbol = window.Shopify?.currency?.active || '';
        buttonElement.innerHTML = `${buttonText} - <span class="money">${formattedPrice.format(total_price / 100)} ${currencySymbol}</span>`;
      } else {
        buttonElement.innerHTML = buttonText;
      }
    }
  }

  customShipUpdate(total_price) {
    const threshold = window.cartSettings?.shippingThreshold || 0;
    const shippingElement = document.querySelector('.custom_shipping span');
    
    if (!shippingElement) return;

    const formattedPrice = getFormattedPrice();
    
    if (threshold > total_price) {
      let shippingRemainingText = window.cartSettings?.shippingRemainingText || 'Voeg er [xxx] meer toe voor gratis verzending';
      const remainingAmount = formattedPrice.format((threshold - total_price) / 100);
      shippingRemainingText = shippingRemainingText.replaceAll('[xxx]', remainingAmount);
      shippingElement.innerHTML = shippingRemainingText;
    } else {
      const shippingCompleteText = window.cartSettings?.shippingCompleteText || 'Je komt in aanmerking voor gratis verzending!';
      shippingElement.innerHTML = shippingCompleteText;
    }
  }

  updateDrawerShippingBar(total_price) {
    const text = document.getElementById('CartDrawer-ShippingText');
    const progress = document.getElementById('CartDrawer-ShippingProgress');
    if (!text && !progress) return;

    const threshold = window.cartSettings?.cartShippingBarThreshold || 0;
    if (!threshold) return;

    const formattedPrice = getFormattedPrice();

    if (total_price >= threshold) {
      if (text) text.textContent = window.cartSettings?.cartShippingBarCompleteText || '';
      if (progress) progress.style.width = 'calc(100% + 2px)';
    } else {
      let remainingText = window.cartSettings?.cartShippingBarRemainingText || '';
      const remainingAmount = formattedPrice.format((threshold - total_price) / 100);
      remainingText = remainingText.replaceAll('[xxx]', remainingAmount);
      if (text) text.textContent = remainingText;
      const pct = Math.min(100, (total_price / threshold) * 100);
      if (progress) progress.style.width = `calc(${pct}% + 2px)`;
    }
  }

  async checkMystry(items, item_count) {
    const mystryVariantId = window.cartSettings?.mystryGiftVariantId;
    const requiredProductCount = window.cartSettings?.requiredProductCount || 0;
    
    if (!mystryVariantId) return;

    let productAdded = false;
    items.forEach((item) => {
      if (item.id == mystryVariantId) {
        productAdded = true;
        return true;
      }
    });
    if(productAdded && item_count == 1){
      await this.addProduct(mystryVariantId, 0);
    }else{
      if (!productAdded && item_count >= requiredProductCount) {
        await this.addProduct(mystryVariantId, 1);
      } else if (item_count < requiredProductCount) {
        await this.addProduct(mystryVariantId, 0);
      }
    }
  }

  async addProduct(productId, quantity) {
    const formData = new FormData();
    formData.append(`updates[${productId}]`, quantity);

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      });
      
      const data = await response.json();
      
      // Refresh cart drawer with updated content
      await this.refreshCartDrawer();
      
      // Dispatch event for other listeners
      let productCardAdd = new Event('sw:added', { bubbles: true });
      document.dispatchEvent(productCardAdd);
    } catch (error) {
      console.log('Add product error:', error.message);
    }
  }

  async refreshCartDrawer() {
    try {
      // Fetch cart sections using Section Rendering API
      const sections = this.getSectionsToRender().map(section => section.section).join(',');
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=${sections}`);
      const sectionsData = await response.json();
      
      // Update each section with fresh HTML
      this.getSectionsToRender().forEach(section => {
        const sectionHTML = sectionsData[section.section];
        if (sectionHTML) {
          const sectionElement = document.querySelector(section.id);
          if (sectionElement) {
            const newHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
            sectionElement.innerHTML = newHTML;
          }
        }
      });
      
      // Cart button and shipping updates are handled by handleCartUpdate via sw:added event
      
    } catch (error) {
      console.log('Cart drawer refresh error:', error.message);
    }
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    cartLink?.setAttribute('role', 'button');
    cartLink?.setAttribute('aria-haspopup', 'dialog');
    cartLink?.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink?.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.addEventListener(
      'transitionend',
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );
    bodyScroll.lock(this.querySelector('[role="dialog"]'));
    let drawerOpen = new Event('drawerOpen', { bubbles: true });
    document.dispatchEvent(drawerOpen);
    if (document.querySelector('product-bar')) {
      document.querySelector('product-bar').style.opacity = '0';
    }
  }

  close() {
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);

    const isHeaderMenuOpen = header.classList.contains('menu-open');

    if (isHeaderMenuOpen) {
      return;
    }

    bodyScroll.unlock(this.querySelector('[role="dialog"]'));
    let drawerClose = new Event('drawerClose', { bubbles: true });
    document.dispatchEvent(drawerClose);
    // if we are on the cart page, resubmit form
    if (window.location.pathname === '/cart') {
      const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }

    if (document.querySelector('product-bar')) {
      document.querySelector('product-bar').removeAttribute('style');
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector('[data-drawer-close]');
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true) {
    if (!response || !response.sections) return;
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      const sectionHTML = response.sections[section.section];
      if (sectionElement && sectionHTML) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          sectionHTML,
          section.selector
        );
      }
    });
    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
